export default __webpack_public_path__ + "static/media/es-pv.544d6d0f.svg";